import { createFileRoute, redirect } from "@tanstack/react-router";

/** @note 未実装のため Registry にリダイレクト */
export const Route = createFileRoute("/_staff/public-ids/_list/alerts/")({
  beforeLoad: () => {
    throw redirect({ to: "/public-ids/registry" });
  },
});
